import styled from "@emotion/styled";
import { Table, TableCell, TableHead } from "@mui/material";

export const StyledTable = styled(Table)`
  width: 100%;
  overflow-x: auto;
`;

export const StyledTableHead = styled(TableHead)`
  background-color: #1b365d;
`;

export const StyledTableCell = styled(TableCell)`
  color: white;
  /* border: 1px solid rgba(224, 224, 224, 1); */
`;
